import { firestore } from "firebase/app";
import "firebase/firestore";
import Words from "@/app/Words";
import { DocumentDataType, GameArgsType } from "@/types";

const COLLECTION = "games";

export default class Game {
  gameId: string;
  userId: string;

  constructor(gameId: string, userId: string) {
    this.gameId = gameId;
    this.userId = userId;
  }

  get doc() {
    return firestore()
      .collection(COLLECTION)
      .doc(this.gameId);
  }

  boot(id: string) {
    return this.doc.set({ players: { [id]: firestore.FieldValue.delete() } }, { merge: true });
  }

  leave() {
    return this.doc.set(
      { players: { [this.userId]: firestore.FieldValue.delete() } },
      { merge: true }
    );
  }

  write(game: GameArgsType | null, options = { merge: true }) {
    return game ? this.doc.set(game, options) : this.doc.delete();
  }

  static generateId(): Promise<string> {
    return new Promise((resolve, reject) => {
      const id = [Words.randomAdjective(), Words.randomNoun()].join("-");
      Game.idExists(id)
        .then((exists) => resolve(exists ? this.generateId() : id))
        .catch(reject);
    });
  }

  static get(id: string): Promise<DocumentDataType> {
    return firestore()
      .collection(COLLECTION)
      .doc(id)
      .get();
  }

  static idExists(id: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      Game.get(id)
        .then(({ exists }) => resolve(exists))
        .catch(reject);
    });
  }
}
